import React from "react";
import { isVideoFile } from "../utils/mediaUtils";

function PlaceGrid({ places, navigate }) {
  if (!places || places.length === 0) {
    return <div>No saved places yet.</div>;
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '3px', marginTop: '20px', marginLeft: '-15px', marginRight: '-15px'}}>
      {places.map((place, index) => {
        const thumbnail = place.images?.[0];
        const isVideo = isVideoFile(thumbnail);

        return (
          <div
            key={`${place.place_id}-${place.trippin_post_id}`}
            style={{
              position: 'relative',
              width: '100%',
              paddingBottom: 'calc(100% * 4 / 3)',
              overflow: 'hidden',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={() =>
              navigate(`/places/${place.place_ids[0]}`,
                place.placeIds
              )
            }
          
          >
            {isVideo ? (
              <video
                src={thumbnail}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
                autoPlay
                loop
                muted
                playsInline
              />
            ) : (
              <img
                src={thumbnail || "/defaultPlaceBg.jpg"}
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  top: 0,
                  left: 0,
                }}
                alt="Place Thumbnail"
              />
            )}

            {/* Place label */}
            <div
              style={{
                position: 'absolute',
                bottom: '5px',
                left: '5px',
                // backgroundColor: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                padding: '4px 6px',
                fontSize: '0.8rem',
              }}
            >
              {place.place_name && <span>{place.place_name}</span>}
            </div>   
          </div>
        );
      })}
    </div>
  );
}

export default PlaceGrid;
